export default function Caption( props ) {

    const { className, children } = props;

    return (
        <p className={ "uppercase text-bb font-bold" + (className ? " " + className : "") }>
            { children }
        </p>
    )
}